import createVueApp from '@/common/create_app'

async function initOrgSettingsPage(componentImport, props) {
  const [{ default: Component }, { default: Layout }] = await Promise.all([
    componentImport,
    import('@/vue_widgets/organization_settings/OrganizationSettingsLayout.vue')
  ])
  createVueApp(Component, {
    props,
    layout: Layout
  })
}

Styxie.Initializers.Users = {
  index: (props) => initOrgSettingsPage(
    import('@/vue_widgets/organization_settings/team_members/index.vue'),
    props
  ),
  new: (props) => initOrgSettingsPage(
    import('@/vue_widgets/organization_settings/form/index.vue'),
    props
  ),
  create: (props) => initOrgSettingsPage(
    import('@/vue_widgets/organization_settings/form/index.vue'),
    props
  ),
  edit: (props) => initOrgSettingsPage(
    import('@/vue_widgets/organization_settings/form/index.vue'),
    props
  ),
  update: (props) => initOrgSettingsPage(
    import('@/vue_widgets/organization_settings/form/index.vue'),
    props
  )
}
